if (!customElements.get('combined-listing-card')) {
  class CombinedListing extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this.defineSelectors();
        this.bindEvents();
      });
    }

    defineSelectors() {
      this.inputs = this.querySelectorAll('.variant-selector__input');
      this.json = this.querySelector('script.product-json');
      this.ns = this.json?.id || ''; // product handle as namespace

      this.titleEl = this.querySelector('.combined-listing__title');
      this.imageEl = this.querySelector('.combined-listing__card-image a img:first-child');
      this.imageHoverEl = this.querySelector('.combined-listing__card-image a img:last-child');
      this.badges = this.querySelectorAll('.product-card-item__meta-badges .product-card-item__meta-badge');
      this.colourFieldset = this.querySelector('.variant-selector__fieldset-colour');
      this.featuresEl = this.querySelector('.combined-listing__features');
      this.buttonEl = this.querySelector('.combined-listing__card-button a');
      this.textLink = this.querySelector('.combined-listing__card-link');
      this.micro = this.querySelector('.product-card-item__supporting');
    }

    bindEvents() {
      this.inputs.forEach(input => {
        input.addEventListener('change', () => this.swapProduct(input));
      });
    }

    parseJSON() {
      try {
        return JSON.parse(this.json.textContent);
      } catch (err) {
        console.error('Invalid product JSON', err);
        return [];
      }
    }

    getSelectedSize(productData) {
      const sizeInput = this.querySelector(`.variant-selector__input[name="${this.ns}-sizes"]:checked`);
      if (!sizeInput) return null;
      return productData.find(s => String(s.capacity) === String(sizeInput.value));
    }

    updateTitle(text) {
      if (this.titleEl) this.titleEl.textContent = text;
    }

    updateMicro(text) {
      if (this.micro) this.micro.textContent = text;
    }

    updateImage(image, hoverImage) {
      if (this.imageEl && image) {
        this.imageEl.src = image;
        this.imageEl.srcset = image;
      }
      if (this.imageHoverEl && hoverImage) {
        this.imageHoverEl.src = hoverImage;
        this.imageHoverEl.srcset = hoverImage;
      }
    }

    updateBadges(data) {
      this.badges.forEach(badge => {
        const key = badge.dataset.badge;
        const value = data[key] ?? '';
        const span = badge.querySelector('span');
        if (span) span.innerText = value;
      });
    }

    updateFeatures(data) {
      if (!this.featuresEl) return;
      let ul = this.featuresEl.querySelector('ul');
      if (!ul) {
        ul = document.createElement('ul');
        this.featuresEl.appendChild(ul);
      }
      ul.innerHTML = '';
      if (Array.isArray(data.features)) {
        data.features.forEach(f => {
          const li = document.createElement('li');
          li.textContent = f.feature;
          ul.appendChild(li);
        });
      }
    }

    renderColourOptions(sizeObj) {
      if (!this.colourFieldset) return;
      const legend = this.colourFieldset.querySelector('legend');
      this.colourFieldset.innerHTML = '';
      if (legend) this.colourFieldset.appendChild(legend);

      sizeObj.colours.forEach((colourObj, index) => {
        const slug = colourObj.colour.toLowerCase().replace(/\s+/g, '-');
        const inputId = `${this.ns}-colour-${slug}-${index}`;
        const inputName = `${this.ns}-colours`;

        const inputEl = document.createElement('input');
        inputEl.type = 'radio';
        inputEl.className = 'variant-selector__input';
        inputEl.id = inputId;
        inputEl.name = inputName;
        inputEl.value = colourObj.colour.toLowerCase();
        inputEl.dataset.type = 'colour';
        if (index === 0) inputEl.checked = true;

        const labelEl = document.createElement('label');
        labelEl.className = 'variant-selector__label variant-selector__colour';
        labelEl.htmlFor = inputId;

        const spanEl = document.createElement('span');
        spanEl.style.background = colourObj.hex || '#000';
        labelEl.appendChild(spanEl);

        this.colourFieldset.appendChild(inputEl);
        this.colourFieldset.appendChild(labelEl);

        inputEl.addEventListener('change', e => this.swapProduct(e.target));
      });
    }

    swapProduct(input) {
      const type = input.dataset.type;
      const productData = this.parseJSON();
      const sizeObj = this.getSelectedSize(productData);

      if (!sizeObj) {
        console.warn('Selected size not found');
        return;
      }

      if (type === 'size') {
        this.updateTitle(sizeObj.parent_title);
        this.updateImage(sizeObj.image, sizeObj.image_hover);
        this.updateBadges(sizeObj);
        this.renderColourOptions(sizeObj);
        this.updateFeatures(sizeObj);
        this.updateMicro(sizeObj.micro_description);
        if (this.buttonEl) this.buttonEl.href = sizeObj.parentUrl;
        if (this.textLink) this.textLink.href = sizeObj.parentUrl;
      }

      if (type === 'colour') {
        const selectedColour = input.value.toLowerCase();
        const colourObj = sizeObj.colours.find(c =>
          c.colour.toLowerCase() === selectedColour || c.title.toLowerCase() === selectedColour
        );

        if (!colourObj) {
          console.warn('Selected colour not found for this size:', selectedColour);
          return;
        }

        const combinedData = { ...sizeObj, ...colourObj };
        console.log('Selected combination:', combinedData);

        this.updateTitle(colourObj.parent_title);
        this.updateImage(colourObj.image, colourObj.image_hover);
        this.updateBadges(combinedData);
        this.updateFeatures(combinedData);
        this.updateMicro(combinedData.micro_description);
        if (this.buttonEl) this.buttonEl.href = colourObj.url;

        if (this.textLink) this.textLink.href = colourObj.url;
      }
    }
  }

  customElements.define('combined-listing-card', CombinedListing);
}
